module.exports = __webpack_public_path__ + "assets/img/37_1631_big.cadadac0.jpg";